__turbopack_context__.v({
  "bullet": "UJvn5G_bullet",
  "card": "UJvn5G_card",
  "eyebrow": "UJvn5G_eyebrow",
  "gradient": "UJvn5G_gradient",
  "grid": "UJvn5G_grid",
  "head": "UJvn5G_head",
  "heading": "UJvn5G_heading",
  "inner": "UJvn5G_inner",
  "label": "UJvn5G_label",
  "note": "UJvn5G_note",
  "noteText": "UJvn5G_noteText",
  "num": "UJvn5G_num",
  "section": "UJvn5G_section",
  "shader": "UJvn5G_shader",
  "top": "UJvn5G_top",
});
